import { FC, PropsWithChildren } from "react";

export const Blockquote: FC<PropsWithChildren> = ({ children }) => (
  <blockquote className="leading-none">
    &ldquo;{ children }&rdquo;
  </blockquote>
);
